// !projets et offres sont la même entité, mais avec seulement des statuts différents -> code à refactoriser un peu

import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors";
import imgModify from "../../assets/images/icones/modify.png";

import ModalProjet from "../Modales/ModalProjet";
import imgPlus from "../../assets/images/icones/plus.png";
import imgMoins from "../../assets/images/icones/moins.png";
import sommeMontants from "../../utils/functions/sommeMontants";

const OffresContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    h1 {
        padding: 10px 80px;
    }
`;

const StyledFilters = styled.div`
    height: 80px;
    display: flex;
    justify-content: space-start;
    gap: 15px;
    align-items: center;
    background-color: ${colors.dark};
    padding: 10px;
    margin: 10px 0 20px 0;
    color: white;
    label {
        color: ${colors.primary};
        font-size: 1.2rem;
        padding-left: 3px;
    }
    h2 {
        padding-left: 20px;
        font-weight: bold;
        margin-right: 20px;
    }
    select {
        /* width: 200px; */
        padding: 0 5px;
        border-radius: 5px;
    }
    .ordreTri {
        padding-left: 20px;
        width: 80px;
        text-align: center;
    }
   
`;

const StyledTable = styled.table`
    width: 100%;
    margin: 40px 0;
`;
const FirstTr = styled.tr`
    background-color: ${colors.dark};
    color: white;
    font-size: 1.5rem;
    height: 60px;
    th {
        padding: 3px 5px;
    }
`;
const LastTr = styled.tr`
    background-color: ${colors.dark};
    color: white;
    font-size: 1.3rem;
    height: 40px;
    
    td {
        padding: 3px 5px;
    }
    text-align: center;
`;


const StyledTr = styled.tr`
    &:nth-child(odd) {
        background-color: #f0f8ff;
    }
    height: 40px;
    text-align: center;
    td:nth-child(1) {
        text-align: left;
        padding-left: 5px;
        padding-right: 5px;
    }
    .vign {
        border-radius: 8px;
        margin: 5px;
        padding: 5px;
        width: 100%;
    }
    .EC {
        background-color: #fff8d6;
    }
    .OA {
        background-color: #dadada;
    }
    .OP {
        background-color: #ffd6d6;
    }
    .AR {
        background-color: #ffd1a6;
    }

    .statut {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .contact {
        display: flex;
        justify-content: space-between;
        padding-left: 15px;
    }

    .dateEtape {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .montant {
        padding: 10px;
    }

    button {
        border: none;
        margin-right: 10px;
        background-color: transparent;
        cursor: pointer;
    }

    button.nomProjet {
        border: 2px solid #e0e0e0;
        background-color: transparent;
        color: ${colors.secondary};
        border-radius: 30px;
        padding: 8px 12px;
        margin: 1px;
        font-weight: bold;

        &:hover {
            text-decoration: underline;
        }
    }
`;

const OffreAdd = styled.div`
    display: flex;
    padding: 10px 0 0px 10%;
    justify-content: start;
    align-items: center;

    h2 {
        padding: 10px;
    }
    button {
        width: 50px;
        height: 50px;
        border-radius: 10px;
        border: none;
        margin: 0 5px 5px 5px;
        cursor: pointer;
    }
    .addOffre {
        background-color: ${colors.primary};
    }
    .deleteOffre {
        background-color: rgb(249, 64, 64);
    }
`;

const Offres = ({
    dataObjects,
    setSelectedTriOffres,
    selectedTriOffres,
    setDirectionTriOffres,
    directionTriOffres,
    setRefreshFlag,
    handleProjet,
}) => {
    // fonction qui permet de remplir la colonne statut
    const renderStatutCell = (dataObject) => {
        const statutLabels = {
            EC: { className: "EC", label: "En cours/Bloquée" },
            OA: { className: "OA", label: "Offre annulée" },
            OP: { className: "OP", label: "Offre perdue" },
            AR: { className: "AR", label: "Offre à relancer" },
        };

        const content = statutLabels[dataObject.statut];
        if (!content) return null;

        return (
            <td className="statut">
                <p className={`vign ${content.className}`}>{content.label}</p>
                <button
                    onClick={() => offreModal("updateStatut", dataObject)}
                    id={dataObject.id}
                >
                    <img
                        className="modify"
                        src={imgModify}
                        alt="modification"
                        height="26px"
                    />
                </button>
            </td>
        );
    };

    // gestion des modales de changement des offres (Statut, dateEtape, )
    //booléen d'affichage des modales
    const [showModalUpdateRef, setShowModalUpdateRef] = useState(false);
    const [showModalUpdateStatut, setShowModalUpdateStatut] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);

    const [offre, setOffre] = useState("");
    const [listContact, setListContact] = useState([[]]);
    const [listOA, setListOA] = useState([[]]);

    const offreModal = (content, offre) => {
        const actions = {
            updateReferent: () => prepareUpdateRef(offre.id),
            updateStatut: () => setShowModalUpdateStatut(true),
            add: () => setShowModalAdd(true),
            delete: () => prepareListOA(),
        };
        // Exécuter l'action correspondant à "content", s'il existe ?. : opérateur d'accès optionnel , n'agit que si cela existe
        actions[content]?.();
        setOffre(offre);
    };
    // fonction qui prépare le fetch des contacts puis l'ouverture de la modale pour updateRef (modale de mise à jour du contact référent de l'offre)
    const prepareUpdateRef = async (id) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/admin/offre/fetchContactByOffre`,
                {
                    method: "POST",
                    credentials: "include",
                    body: JSON.stringify({
                        projet_id: id,
                    }),
                }
            );
            const data = await response.json();
            // console.log(deletedEntreprise.status);

            if (!response.ok) {
                console.error("Erreur de chargement des contacts" + data);
            } else {
                setListContact(data["content"]);
                setShowModalUpdateRef(true);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des contacts", error);
        }
    };
    // fonction qui appelle l'API pour préparer la liste des Offres qui peuvent être supprimées du CRM (offres annulées uniquement)
    const prepareListOA = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/admin/offre/fetchListeOffresAnnulées`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );
            const data = await response.json();
            //    console.log(data);

            if (!response.ok) {
                console.log(
                    "Erreur de chargement des données des Offres annulées"
                );
            } else {
                setListOA(data["content"]);
                setShowModalDelete(true);
            }
        } catch (error) {
            console.log(
                "Erreur lors de la récupération des Offres Annulées: " + error
            );
        }
    };

    const handleChange = (event) => {
        if (event.target.name === "triOffres") {
            setSelectedTriOffres(event.target.value);
        } else if (event.target.name === "direction") {
            setDirectionTriOffres(event.target.value);
        }
        // setRefreshFlag((prev)=>!prev);
    };

    const handleCloseModale = (content) => {
        const actions = {
            updateReferent: () => setShowModalUpdateRef(false),
            updateStatut: () => setShowModalUpdateStatut(false),
            add: () => setShowModalAdd(false),
            delete: () => setShowModalDelete(false),
        };
        // Exécuter l'action correspondant à "content", s'il existe ?. : opérateur d'accès optionnel , n'agit que si cela existe
        actions[content]?.();
        setOffre("");
    };

  
    

    // *Code qui était utile lorsque la date était affichée dans 'Custom-date-input'
    // const convertToISODate = (datetime) => {
    //     if (!datetime) {
    //         // Si la date est null, undefined ou vide, retourne une chaîne vide
    //         return "";
    //     }
    //     // Convertir la chaîne datetime en objet Date
    //     const date = new Date(datetime);

    //     // Obtenir les composantes de la date
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, "0"); // Mois (1 à 12)
    //     const day = String(date.getDate()).padStart(2, "0"); // Jour (01 à 31)

    //     // Retourner la date au format YYYY-MM-DD
    //     return `${year}-${month}-${day}`;
    // };

    return (
        <>
            <OffresContainer>
                <h1>Tableau des offres</h1>
                <OffreAdd>
                    <button
                        onClick={() => offreModal("add", "")}
                        className="addOffre"
                    >
                        <img src={imgPlus} alt="addOffre" height="32px" />
                    </button>
                    <h2>Ajouter une nouvelle offre</h2>
                </OffreAdd>
                <OffreAdd>
                    <button
                        onClick={() => offreModal("delete", "")}
                        className="deleteOffre"
                    >
                        <img src={imgMoins} alt="deleteOffre" height="32px" />
                    </button>
                    <h2>Supprimer une offre (Offres annulées exclusivement)</h2>
                </OffreAdd>
                <StyledFilters>
                    <h2>Trier par</h2>
                    <div>
                        <input
                            type="radio"
                            id="entreprise"
                            name="triOffres"
                            value="entreprise"
                            checked={selectedTriOffres === "entreprise"}
                            onChange={handleChange}
                        />
                        <label htmlFor="entreprise">Entreprise</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="nom"
                            name="triOffres"
                            value="nom"
                            checked={selectedTriOffres === "nom"}
                            onChange={handleChange}
                        />
                        <label htmlFor="nom_offre">Nom d'offre</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="date_creation"
                            name="triOffres"
                            value="date_creation"
                            checked={selectedTriOffres === "date_creation"}
                            onChange={handleChange}
                        />
                        <label htmlFor="dateCreation">Date de création</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="date_etape"
                            name="triOffres"
                            value="date_etape"
                            checked={selectedTriOffres === "date_etape"}
                            onChange={handleChange}
                        />
                        <label htmlFor="dateEtape">Date Etape</label>
                    </div>

                    <div>
                        <input
                            type="radio"
                            id="statut"
                            name="triOffres"
                            value="statut"
                            checked={selectedTriOffres === "statut"}
                            onChange={handleChange}
                        />
                        <label htmlFor="statut">Statut</label>
                    </div>

                    <div className="ordreTri">
                        <label htmlFor="dateCreation">Sens:</label>
                        <select
                            name="direction"
                            id="direction"
                            onChange={handleChange}
                            value={directionTriOffres}
                        >
                            <option value="ASC">Ascendant</option>
                            <option value="DESC">Descendant</option>
                        </select>
                    </div>
                </StyledFilters>

                <StyledTable>
                    <tbody>
                        <FirstTr>
                            <th>Client</th>
                            <th>Contact référent</th>
                            <th>N° d'offre</th>
                            <th>Nom de l'offre</th>
                            <th>Montant XOF</th>
                            <th>Montant €</th>
                            {/* <th>Mise en ligne</th> */}
                            {/* <th>Date étape</th> */}
                            <th>Statut</th>
                        </FirstTr>
                        {dataObjects.map((dataObject, index) => (
                            <StyledTr key={index}>
                                <td>{dataObject.entreprise}</td>
                                <td>
                                    <div className="contact">
                                        <div>
                                            {dataObject.contactSexe === "M"
                                                ? "Mr"
                                                : "Mme"}{" "}
                                            {dataObject.contactNom}{" "}
                                        </div>
                                        <button
                                            onClick={() =>
                                                offreModal(
                                                    "updateReferent",
                                                    dataObject
                                                )
                                            }
                                            id={dataObject.id}
                                        >
                                            {" "}
                                            <img
                                                className="modify"
                                                src={imgModify}
                                                alt="modification"
                                                height="26px"
                                            />
                                        </button>
                                    </div>
                                </td>
                                <td>{dataObject.numeroOffre}</td>
                                <td>
                                    <button
                                        className="nomProjet"
                                        onClick={() =>
                                            handleProjet(dataObject.id)
                                        }
                                    >
                                        {dataObject.nom}
                                    </button>
                                </td>
                                <td className="montant">
                                    {dataObject.montant}
                                </td>
                                <td>
                                    {Math.round(
                                        dataObject.montant * 0.001524 * 100
                                    ) / 100}
                                </td>
                                {/* date mise en ligne */}
                                {/* <td>
                                    {dataObject.dateCreation?.date
                                        ? formatDate2(
                                              dataObject.dateCreation.date
                                          )
                                        : ""}
                                </td> */}
                                {/* dateEtape */}
                                {/* <td>
                                    <div>{dataObject?.typeEtape}</div>
                                    <div>
                                        {dataObject?.dateEtape?.date ? (
                                            formatDate2(
                                                dataObject.dateEtape.date
                                            )
                                        ) : (
                                            <span className="placeholder">
                                                Aucune
                                            </span>
                                        )}
                                    </div>
                                </td> */}

                                {/* Appel de la fonction pour générer le contenu du statut */}
                                {renderStatutCell(dataObject)}
                            </StyledTr>
                        ))}
                        <LastTr>
                            <td colSpan={4}>Totaux</td>
                            <td>{sommeMontants(dataObjects)} XOF</td>
                            <td>
                                {Math.round(
                                    sommeMontants(dataObjects) * 0.001524 * 100
                                ) / 100} €
                            </td>
                            <td></td>
                        </LastTr>
                    </tbody>
                </StyledTable>
            </OffresContainer>
            {showModalUpdateRef && (
                <ModalProjet
                    content="updateReferent"
                    type="offre"
                    handleClose={(content) => handleCloseModale(content)}
                    listContact={listContact}
                    dataProjet={offre}
                    setRefreshFlag={setRefreshFlag}
                />
            )}
            {showModalUpdateStatut && (
                <ModalProjet
                    content="updateStatut"
                    type="offre"
                    handleClose={(content) => handleCloseModale(content)}
                    dataProjet={offre}
                    setRefreshFlag={setRefreshFlag}
                />
            )}
            {showModalAdd && (
                <ModalProjet
                    content="add"
                    type="offre"
                    handleClose={(content) => handleCloseModale(content)}
                    setRefreshFlag={setRefreshFlag}
                />
            )}
            {showModalDelete && (
                <ModalProjet
                    content="delete"
                    type="offre"
                    listOA={listOA}
                    handleClose={(content) => handleCloseModale(content)}
                    setRefreshFlag={setRefreshFlag}
                />
            )}
        </>
    );
};

export default Offres;
